import { render, staticRenderFns } from "./DeviceDefectRecord.vue?vue&type=template&id=3d650461&scoped=true"
import script from "./DeviceDefectRecord.vue?vue&type=script&lang=js"
export * from "./DeviceDefectRecord.vue?vue&type=script&lang=js"
import style0 from "./DeviceDefectRecord.vue?vue&type=style&index=0&id=3d650461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d650461",
  null
  
)

export default component.exports